<template>
    <div>
        <v-app class="p-4">
            <div class="col-md-12 p-0 mt-5 pt-10 mx-auto" style="border: none!important;">
                <v-tooltip right>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn text class="float-left" small @click="getDataForTable(url)" v-bind="attrs"
                               v-on="on"><span class="material-icons">refresh</span></v-btn>
                    </template>
                    <span>به روز رسانی لیست مشتریان</span>
                </v-tooltip>
                <template>
                    <v-row justify="center">
                        <v-dialog
                                v-if="relatedModal"
                                v-model="relatedModal"
                                max-width="1300"
                                hide-overlay
                                transition="dialog-bottom-transition"
                        >
                            <v-card>
                                <v-toolbar
                                        flat
                                        dark
                                        color="primary"
                                >

                                    <v-toolbar-title>ویرایش اطلاعات مشتری</v-toolbar-title>
                                    <v-spacer></v-spacer>
                                    <v-toolbar-items>
                                        <v-btn
                                                icon
                                                dark
                                                @click="relatedModal = false"
                                        >
                                            <v-icon>mdi-close</v-icon>
                                        </v-btn>
                                    </v-toolbar-items>
                                </v-toolbar>
                                <new-customer :reload="reloadTable" :modal="()=>{this.relatedModal=false}" :edit="this.related_id"></new-customer>
                            </v-card>
                        </v-dialog>
                    </v-row>
                </template>
                <template>
                    <v-row justify="center">
                        <v-dialog
                                v-if="historyModal"
                                v-model="historyModal"
                                max-width="1200"
                                hide-overlay
                                transition="dialog-bottom-transition"
                        >
                            <v-card>
                                <v-toolbar
                                        flat
                                        dark
                                        color="primary"
                                >

                                    <v-toolbar-title>مشاهده لیست تاریخچه ها</v-toolbar-title>
                                    <v-spacer></v-spacer>
                                    <v-toolbar-items>
                                        <v-btn
                                                icon
                                                dark
                                                @click="historyModal = false"
                                        >
                                            <v-icon>mdi-close</v-icon>
                                        </v-btn>
                                    </v-toolbar-items>
                                </v-toolbar>
                                <list-history :estate="false" :id="related_id"></list-history>
                            </v-card>
                        </v-dialog>
                        <v-dialog
                                v-if="showMore"
                                v-model="showMore"
                                max-width="1200"
                                hide-overlay
                                transition="dialog-bottom-transition"
                        >
                            <v-card>
                                <v-toolbar
                                        flat
                                        dark
                                        color="primary"
                                >

                                    <v-toolbar-title>اطلاعات بیشتر آگهی</v-toolbar-title>
                                    <v-spacer></v-spacer>
                                    <v-toolbar-items>
                                        <v-btn
                                                icon
                                                dark
                                                @click="showMore = false"
                                        >
                                            <v-icon>mdi-close</v-icon>
                                        </v-btn>
                                    </v-toolbar-items>
                                </v-toolbar>
                                <more-information :information="related_id"></more-information>
                            </v-card>
                        </v-dialog>
                    </v-row>
                </template>
                <!--      end edit mode -->

                <v-tabs v-model="tab" color="deep-purple accent-4" class="mt-5" grow
                >
                    <v-tab v-for="item in TabsName" :key="item.value">{{ item.name }}</v-tab>
                </v-tabs>

                <v-tabs-items v-model="tab">
                    <v-tab-item>
                        <v-card v-if="tab === 0" :loading="loading" class="p-3 pt-0">

                            <terminal-table class="col-12" :currentPage="datas.current_page"
                                            :perPage="datas.per_page" v-if="isMobile" :getData="getDataForTable"
                                            :pageCount="datas.last_page"
                                            :options="tableProps" :datas="datas" :headers="columns"></terminal-table>

                            <data-table
                                    v-else
                                    :data="datas"
                                    :columns="columns"
                                    :debounce-delay="3000"
                                    :pagination="paginate"
                                    :orderBy="tableProps.column"
                                    :orderDir="tableProps.dir"
                                    :translate="translate"
                                    :per-page="[10, 25, 50, 100, 500]"
                                    @on-table-props-changed="reloadTable"
                                    class="pt-5 mt-5 table-striped text-center table-hover table-responsive-lg table-responsive-md table-responsive-sm table-responsive-xs"
                            ></data-table>
                        </v-card>
                    </v-tab-item>
                    <v-tab-item>
                        <new-customer :tab="tab" v-if="tab == 1"></new-customer>
                    </v-tab-item>
                </v-tabs-items>

            </div>
        </v-app>
    </div>
</template>
bu
<script>
import {dataTableProps} from "@/main";
import {debounce} from "../../../../custom";
import button from "../../button";
import NewCustomer from "./newCustomer";
import addHistory from "@/view/pages/divar/states/addHistory";
import ListHistory from "../states/history/listHistory";


export default {
    name: "customerList",
    components: {ListHistory, NewCustomer,addHistory},
    data() {
        return {
            tarafeName: "",
            TabsName: [{name: 'لیست مشتریان ', value: 'list'}, {name: 'ثبت مشتری جدید', value: 'newCustomer'}],
            tab: "",
            authModal: false,
            historyModal: false,
            loading: false,
            adsModal: false,
            relatedModal: false,
            related_id: null,
            datas: {},
            mine: [],
            myRes: [],
            activeComponent: '',
            translate: dataTableProps.translate,
            tableProps: dataTableProps.tableProps,
            paginate: dataTableProps.pagination,
            url: `${url}/user/customer`,
            selectedNumber: [],
            dataId: '',
            adsList: '',
            columns: [
                {
                    label: '<input type="checkbox" id="selectAll">',
                    isCheckBox:true,
                    transform: (val) => {
                        return `<input type="checkbox"  data-id="${val.data.phone}">`
                    },
                    orderable: false,
                },
                {
                    label: 'ردیف',
                    transform: (val) => {
                        let row = this.datas.current_page - 1;
                        row = row * this.datas.per_page;
                        return row + val.row + 1;
                    },
                    orderable: true,
                },
                {
                    label: 'نام ',
                    name: 'name',
                    orderable: true,
                    searchable: true,
                },
                {
                    label: 'نام پدر',
                    name: 'father_name',
                    transform: (val) => {
                        return val.data.father_name ? val.data.father_name : '-';
                    },
                    orderable: true,
                    searchable: true,
                },
                {
                    label: 'کدملی',
                    name: 'national_id',
                    orderable: true,
                    searchable: true,
                },
                {
                    label: 'شماره موبایل',
                    primary:true,
                    name: 'mobile',
                    orderable: true,
                    searchable: true,
                },
                {
                    label: 'مدیریت',
                    name: 'action',
                    component: button,
                    event: "actions",
                    meta: {
                        buttons: [
                            {
                                name: 'delete',
                                label: 'حذف',
                                icon: 'trash-alt',
                                class: 'btn-outline-danger',
                                action: this.actions,
                            },
                            {
                                name: 'edit',
                                label: 'ویرایش اطلاعات',
                                icon: 'edit',
                                class: 'btn-outline-warning',
                                action: this.actions,
                            },
                            {
                                name: 'history',
                                label: 'ایجاد تاریخچه',
                                icon: 'history',
                                class: 'btn-outline-success',
                                action: this.actions,
                            },
                        ]
                    }
                },
            ],
            updatedData: [],
            authResult: [],
        }
    },
    methods: {
        translator(name) {
            return this.translates[name];
        },
        getDataForTable(url = this.url, query = this.tableProps) {
            const vm = this;
            vm.loading = true;
            $.ajax({
                url: url,
                type: 'GET',
                fn: this.getDataForTable,
                data: query,
                headers: {
                    "ACCEPT": "application/json",
                    "Authorization": Token
                },
                success: function (data) {
                    vm.datas = data.data;
                    vm.loading = false;
                }
            })
        },
        reloadTable(tableProps) {
            debounce(() => {
                this.getDataForTable(this.url, tableProps);
            }, 700);
        },
        actions(data, type) {
            this[type + "Action"](data);
        },
        historyAction: function (data) {
            this.historyModal = true;
            this.related_id = data.id
        },
        deleteAction(data) {
            this.$modal.yesNo('تایید حذف', 'آیا از حذف این مشتری اطمینان دارید؟', "neg", '').then((value => {
                if (value === true) {
                    $.ajax({
                        url: `${url}/user/customer/${data.id}`,
                        method: 'DELETE',
                        msg: true,
                        fn: this.deleteAction,
                        headers: {
                            "ACCEPT": "application/json",
                            "Authorization": Token
                        },
                        success: (val) => {
                            this.reloadTable();
                        },
                    });
                }
            }));
        },
       editAction: function (data) {
            this.relatedModal = true;
            this.related_id = data.id
        },
        allowOnlyNumbers(value) {
            if (typeof Number(value.key) !== 'string') {
                let allowedKeys = [8, 46, 38, 40, 37, 39];
                const keypressed = value.which || value.keyCode;
                if (/[^0-9\s]+/.test(value.key)) {
                    if (allowedKeys.every(e => e !== keypressed)) {
                        value.preventDefault();
                    }
                } else return true
            }
        },
        getLocalization() {
            if (localStorage.getItem('localization')) {
                this.translates = JSON.parse(localStorage.getItem('localization'));
                return;
            }
            $.ajax({
                url: `${url}/setting/localization`,
                type: 'GET',
                fn: this.getLocalization,
                headers: {
                    "ACCEPT": "application/json",
                    "Authorization": Token
                },
                success: (data) => {
                    this.translates = data.data
                    localStorage.setItem('localization', JSON.stringify(data.data));
                }
            })
        },
    },
    mounted() {
        this.getDataForTable(this.url);
        this.getLocalization();
        $(document).on('click', '#selectAll', (element) => {
            if ($(element.target).is(':checked')) {
                $('input[type="checkbox"]').prop('checked', true);

                const selected = $('input[type="checkbox"]').map(function () {
                    return $(this).data('id')
                }).get();

                this.selectedNumber = selected;
            } else {
                $('input[type="checkbox"]').prop('checked', false)
                this.selectedNumber = []
            }
        });
    },
    watch: {
        tab: function (val) {
            if (val === 0) {
                this.reloadTable();
            }
        }
    },
    computed: {
        isMobile() {
            switch (this.$vuetify.breakpoint.name) {
                case 'xs':
                    this.getDataForTable(this.url);
                    return true
                case 'sm':
                    this.getDataForTable(this.url);
                    return true
                case 'md':
                    this.getDataForTable(this.url);
                    return false
                case 'lg':
                    this.getDataForTable(this.url);
                    return false
                case 'xl':
                    this.getDataForTable(this.url);
                    return false
            }
        },
    },
}
</script>

<style scoped>

</style>